module.exports = __webpack_public_path__ + "static/media/SeguroNFRNegro.b627e7a1.png";